import { useEffect } from "react";

const ResultScroll = () => {
  useEffect(() => {
    const first = document.querySelector("#first-one");
    const second = document.querySelector("#second-one");
    const animate = (element, position) => {
      element.style.transform = `translateX(${position}px)`;
    };
    let lastKnownScrollPosition;
    document.addEventListener("scroll", function () {
      lastKnownScrollPosition = window.scrollY;
      window.requestAnimationFrame(function () {
        animate(first, lastKnownScrollPosition * 0.8);
        animate(second, lastKnownScrollPosition * -0.8);
      });
    });
  }, []);

  return (
    <div className="overflow-hidden md:pt-24 xl:pt-0">
      <div
        className="overflow-hidden h-[22vh] md:h-[30vh] xl:h-[65vh] w-[200vw]"
        id="container3"
      >
        <h1
          className="transition-transform duration-200 ease-linear text-5xl md:text-8xl xl:text-large font-normal text-black -ml-[290rem] md:-ml-[330rem] xl:-ml-[355rem]"
          id="first-one"
        >
          <span className="font-jomolhari inline-block">WHAT CLIENT</span>
        </h1>
        <h1
          className="transition-transform duration-200 ease-linear text-5xl md:text-8xl xl:text-large font-normal text-black ml-[296rem] md:ml-[330rem] xl:ml-[380rem]"
          id="second-one"
        >
          <span className="font-jomolhari inline-block">ACHIEVED?</span>
        </h1>
      </div>
    </div>
  );
};

export default ResultScroll;
